import { DestinationState } from '@/scopes/destinations/infrastructure/store/destination-store'

export function destinationOptionsSelector(state: DestinationState) {
  const options = state.selectorOptions
  return {
    results: {
      countries: options.country,
      regions: options.region,
      subregions: options.subregion,
      cities: options.city,
    },
    isLoading: state.selectorStatus.isLoading,
    error: state.selectorStatus.hasError,
  }
}

export function popularAccosSelector(state: DestinationState) {
  return {
    results: state.popularAccos,
    isLoading: state.popularAccosStatus.isLoading,
    error: state.popularAccosStatus.hasError,
  }
}

export function mapAccoMarkersSelector(state: DestinationState) {
  return state.mapAccoMarkers
}
